import BellOutlined from '../../../../assets/svgs/bell-outlined.svg'
import BellIcon from '../../../../assets/svgs/bell.svg'
import MediaIcon from '../../../../assets/svgs/media.svg'

import BarChartWhite from '../../../../assets/svgs/bar-chart-white.svg'
import BarChartStandard from '../../../../assets/svgs/bar-chart.svg'
import Cities from '../../../../assets/svgs/cities.svg'
import Countries from '../../../../assets/svgs/countries.svg'
import CurrenciesStandart from '../../../../assets/svgs/currencies-standart.svg'
import Currencies from '../../../../assets/svgs/currencies.svg'
import ECommerceStandart from '../../../../assets/svgs/eccomerce-standart.svg'
import ECommerce from '../../../../assets/svgs/ecommerce.svg'
import Genders from '../../../../assets/svgs/genders.svg'
import PackagingStandart from '../../../../assets/svgs/packaging-standart.svg'
import Packaging from '../../../../assets/svgs/packaging.svg'
import PaymentMethodStandart from '../../../../assets/svgs/payment-method-standart.svg'
import PaymentMethod from '../../../../assets/svgs/payment-method.svg'
import v2ReportWhite from '../../../../assets/svgs/reports-white.svg'
import v2ReportStandard from '../../../../assets/svgs/reports.svg'
import v2AccountSubscriptionStandard from '../../../../assets/svgs/v2-account-subscription-standard.svg'
import v2AccountSubscriptionWhite from '../../../../assets/svgs/v2-account-subscription-white.svg'
import v2AccountVenueSpaceStandard from '../../../../assets/svgs/v2-account-venue-space-standard.svg'
import v2AccountVenueSpaceWhite from '../../../../assets/svgs/v2-account-venue-space-white.svg'
import v2AdvancedAccountStandard from '../../../../assets/svgs/v2-advanced-account-standard.svg'
import v2AdvancedAccountWhite from '../../../../assets/svgs/v2-advanced-account-white.svg'
import v2AnalyticsStandard from '../../../../assets/svgs/v2-analytics-standard.svg'
import v2AnalyticsWhite from '../../../../assets/svgs/v2-analytics-white.svg'
import v2CampaignStandard from '../../../../assets/svgs/v2-campaign-standard.svg'
import v2CampaignWhite from '../../../../assets/svgs/v2-campaign-white.svg'
import v2CustomerStandard from '../../../../assets/svgs/v2-customer_insights-standard.svg'
import v2CustomerWhite from '../../../../assets/svgs/v2-customer_insights-white.svg'
import v2DashboardStandard from '../../../../assets/svgs/v2-dashboard-standard.svg'
import v2DashboardWhite from '../../../../assets/svgs/v2-dashboard-white.svg'
import v2DeliveryStandard from '../../../../assets/svgs/v2-delivery-standard..svg'
import v2DeliveryWhite from '../../../../assets/svgs/v2-delivery-white.svg'
import v2DeliveryPickupStandard from '../../../../assets/svgs/v2-deliverypickup-standard.svg'
import v2DeliveryPickupWhite from '../../../../assets/svgs/v2-deliverypickup-white.svg'
import v2DiscountStandard from '../../../../assets/svgs/v2-discount-standard.svg'
import v2DiscountWhite from '../../../../assets/svgs/v2-discount-white.svg'
import v2DPIStandard from "../../../../assets/svgs/v2-dp-integrate-standard.svg"
import v2DPIWhite from "../../../../assets/svgs/v2-dp-integrate-white.svg"
import v2GuestStandard from '../../../../assets/svgs/v2-guest-standard.svg'
import v2GuestWhite from '../../../../assets/svgs/v2-guest-white.svg'
import v2MarketingStandard from '../../../../assets/svgs/v2-marketing-standard.svg'
import v2MarketingWhite from '../../../../assets/svgs/v2-marketing-white.svg'
import v2MenuCategoryStandard from '../../../../assets/svgs/v2-menu-category-standard.svg'
import v2MenuCategoryWhite from '../../../../assets/svgs/v2-menu-category-white.svg'
import v2MenuInventoryStandard from '../../../../assets/svgs/v2-menu-inventory-standard.svg'
import v2MenuInventoryWhite from '../../../../assets/svgs/v2-menu-inventory-white.svg'
import v2MenuProductStandard from '../../../../assets/svgs/v2-menu-product-standard.svg'
import v2MenuProductWhite from '../../../../assets/svgs/v2-menu-product-white.svg'
import v2MenuStandard from '../../../../assets/svgs/v2-menu-standard.svg'
import v2MenuWhite from '../../../../assets/svgs/v2-menu-white.svg'
import v2OrderAndPayStandard from '../../../../assets/svgs/v2-orderpay-standard.svg'
import v2OrderAndPayWhite from '../../../../assets/svgs/v2-orderpay-white.svg'
import v2POSInventoryStandard from "../../../../assets/svgs/v2-pos-inventory-standard.svg"
import v2POSInventoryWhite from "../../../../assets/svgs/v2-pos-inventory-white.svg"
import v2ReferralStandard from '../../../../assets/svgs/v2-referal-standard.svg'
import v2ReferralWhite from '../../../../assets/svgs/v2-referal-white.svg'
import v2SettingStandard from '../../../../assets/svgs/v2-setting-standard.svg'
import v2SettingWhite from '../../../../assets/svgs/v2-setting-white.svg'
import v2StaffStandard from '../../../../assets/svgs/v2-staff-standard.svg'
import v2StaffWhite from '../../../../assets/svgs/v2-staff-white.svg'
import v2TableStandard from '../../../../assets/svgs/v2-table-standard.svg'
import v2TableWhite from '../../../../assets/svgs/v2-table-white.svg'
import WidgedAddStandart from '../../../../assets/svgs/widged-add-standart.svg'
import WidgedAdd from '../../../../assets/svgs/widget-add.svg'
import { } from '../auto_motorcycle_parts'

export const OnlineShopSidebar = [
	{
		img: v2DashboardStandard,
		imgActive: v2DashboardWhite,
		key: 1,
		name: 'dashboard',
		text: 'Dashboard',
		default: true,
		menus: [
			{
				img: v2DashboardStandard,
				imgActive: v2DashboardWhite,
				name: 'venue-dashboard',
				text: 'General Dashboard',
				key: 1,
			},
			{
				img: v2AnalyticsStandard,
				imgActive: v2AnalyticsWhite,
				name: 'analytics',
				text: 'Inventory Analytics',
				key: 2,
			},
		],
	},
	{
		img: v2MenuStandard,
		imgActive: v2MenuWhite,
		key: 2,
		name: 'menu',
		text: 'Products Management',
		menus: [
			{
				img: v2MenuProductStandard,
				imgActive: v2MenuProductWhite,
				name: 'items',
				text: 'Products',
				key: 2,
			},
			{
				img: v2MenuCategoryStandard,
				imgActive: v2MenuCategoryWhite,
				name: 'categories',
				text: 'Categories',
				key: 3,
			},
			// {
			// 	img: v2MenuInventoryStandard,
			// 	imgActive: v2MenuInventoryWhite,
			// 	name: 'inventory',
			// 	text: 'Inventory',
			// 	key: 4,
			// },
			// {
			// 	img: v2MenuProductStandard,
			// 	imgActive: v2MenuProductWhite,
			// 	name: 'consistent-inventory',
			// 	text: 'Consistent Inventory',
			// 	key: 5,
			// },
			{
				img: v2MenuProductStandard,
				imgActive: v2MenuProductWhite,
				name: 'brands',
				text: 'Brands',
				key: 4,
			},
			{
				img: v2MenuProductStandard,
				imgActive: v2MenuProductWhite,
				name: 'collections',
				text: 'Collections',
				key: 5,
			},
			{
				img: v2AdvancedAccountStandard,
				imgActive: v2AdvancedAccountWhite,
				name: 'attributes',
				text: 'Attributes',
				key: 6,
			},
		],
	},

	{
		img: v2DeliveryStandard,
		imgActive: v2DeliveryWhite,
		key: 3,
		name: 'delivery',
		text: 'Orders',
		menus: [
			{
				img: v2DeliveryPickupStandard,
				imgActive: v2DeliveryPickupWhite,
				name: 'delivery-orders',
				text: 'Orders',
				key: 1,
			},
			// {
			// 	img: v2OrderAndPayStandard,
			// 	imgActive: v2OrderAndPayWhite,
			// 	name: 'surveys-and-ratings',
			// 	text: 'Surveys and Ratings',
			// 	key: 3,
			// },
		],
	},
	{
		img: v2StaffStandard,
		imgActive: v2StaffWhite,
		key: 4,
		name: 'staff',
		text: 'Staff Management',
		menus: [
			{
				img: v2StaffStandard,
				imgActive: v2StaffWhite,
				name: 'employees',
				text: 'Employees',
				key: 1,
			},
			// {
			// 	img: v2TOStandard,
			// 	imgActive: v2TOWhite,
			// 	name: 'time-off-requests',
			// 	text: 'Time off Requests',
			// 	key: 2,
			// },
			// {
			// 	img: v2IntegrationStandard,
			// 	imgActive: v2IntegrationWhite,
			// 	name: 'staff-integrations',
			// 	text: 'Staff Integrations',
			// 	key: 3,
			// },
		],
	},
	{
		img: v2CustomerStandard,
		imgActive: v2CustomerWhite,
		key: 5,
		name: 'customers',
		text: 'Customers Management',
		menus: [
			{
				img: v2CustomerStandard,
				imgActive: v2CustomerWhite,
				name: 'all-customers',
				text: 'All customers',
				key: 1,
			}, {
				img: v2CustomerStandard,
				imgActive: v2CustomerWhite,
				name: 'members',
				text: 'Members',
				key: 2,
			},

		],
	},
	{
		img: v2MarketingStandard,
		imgActive: v2MarketingWhite,
		key: 6,
		name: 'marketing',
		text: 'Marketing',
		menus: [
			{
				img: v2DiscountStandard,
				imgActive: v2DiscountWhite,
				name: 'promotions',
				text: 'Promotions',
				key: 1,
			},
			{
				img: v2ReferralStandard,
				imgActive: v2ReferralWhite,
				name: 'referrals',
				text: 'Referrals',
				key: 2,
			},
			{
				img: v2CampaignStandard,
				imgActive: v2CampaignWhite,
				name: 'campaigns',
				text: 'Campaigns',
				key: 3,
			},
			// {
			// 	img: v2StaffStandard,
			// 	imgActive: v2StaffWhite,
			// 	name: 'enduser-card',
			// 	text: 'Cards',
			// 	key: 4,
			// },
			{
				img: v2OrderAndPayStandard,
				imgActive: v2OrderAndPayWhite,
				name: 'wallet',
				text: 'Wallet',
				key: 5,
			},
			{
				img: v2MarketingStandard,
				imgActive: v2MarketingWhite,
				name: 'quizes',
				text: 'Quizes',
				key: 6,
			},
		],
	},
	{
		img: v2MenuInventoryStandard,
		imgActive: v2MenuInventoryWhite,
		key: 7,
		name: 'inventory-management',
		text: 'Inventory Management',
		menus: [
			{
				img: v2DeliveryPickupStandard,
				imgActive: v2DeliveryPickupWhite,
				name: 'synchronizations',
				text: 'Sync',
				key: 1,
			},
			{
				img: v2DPIStandard,
				imgActive: v2DPIWhite,
				name: 'warehouses',
				text: 'Warehouses',
				key: 2,
			},
			{
				img: v2POSInventoryStandard,
				imgActive: v2POSInventoryWhite,
				name: 'physical-stores',
				text: 'Physical Stores',
				key: 3,
			},
			{
				img: v2OrderAndPayStandard,
				imgActive: v2OrderAndPayWhite,
				name: 'e-commerce-platforms',
				text: 'eCommerce Platforms',
				key: 4,
			},
			{
				img: v2ReportStandard,
				imgActive: v2ReportWhite,
				name: 'reports',
				text: 'Reports',
				key: 5,
			},
			{
				img: BarChartStandard,
				imgActive: BarChartWhite,
				name: 'summary',
				text: 'Summary',
				key: 6,
			},
			{
				img: BarChartStandard,
				imgActive: BarChartWhite,
				name: 'sales-metrics',
				text: 'Sales Metrics',
				key: 7,
			},
		],
	},
	{
		img: v2MenuStandard,
		imgActive: v2MenuWhite,
		key: 8,
		name: 'articles',
		text: 'Articles',
		menus: [
			{
				img: v2MenuProductStandard,
				imgActive: v2MenuProductWhite,
				name: 'list',
				text: 'List',
				key: 1,
			},
			{
				img: v2MenuCategoryStandard,
				imgActive: v2MenuCategoryWhite,
				name: 'categories',
				text: 'Categories',
				key: 2,
			},

		],
	},
	{
		img: ECommerceStandart,
		imgActive: ECommerce,
		key: 9,
		name: 'e-commerce',
		text: 'E-commerce',
		menus: [
			{
				img: WidgedAddStandart,
				imgActive: WidgedAdd,
				name: 'menu-list',
				text: 'Menu List',
				key: 1,
			},
			{
				img: CurrenciesStandart,
				imgActive: Currencies,
				name: 'currencies',
				text: 'Currencies',
				key: 2,
			},
			{
				img: PaymentMethodStandart,
				imgActive: PaymentMethod,
				name: 'payment-method',
				text: 'Payment method',
				key: 3,
			},
			// {
			// 	img: CourierStandart,
			// 	imgActive: Courier,
			// 	name: 'couriers',
			// 	text: 'Couriers',
			// 	key: 4,
			// },
			{
				img: PackagingStandart,
				imgActive: Packaging,
				name: 'packaging',
				text: 'Packaging',
				key: 5,
			},
		],
	},
	{
		img: MediaIcon,
		imgActive: MediaIcon,
		key: 10,
		name: 'media',
		text: 'Media',
		menus: [
			{
				img: v2MarketingStandard,
				imgActive: v2MarketingWhite,
				name: 'promo',
				text: 'Promo',
				key: 1,
			},
			{
				img: v2MenuCategoryStandard,
				imgActive: v2MenuCategoryWhite,
				name: 'slider',
				text: 'Slider',
				key: 2,
			},
			{
				img: BellOutlined,
				imgActive: BellIcon,
				name: 'notifications',
				text: 'Notifications',
				key: 3,
			},

		],
	},
	{
		img: v2SettingStandard,
		imgActive: v2SettingWhite,
		key: 11,
		name: 'settings',
		text: 'Settings',
		menus: [
			{
				img: v2AccountSubscriptionStandard,
				imgActive: v2AccountSubscriptionWhite,
				name: 'subscription',
				text: 'Subscription',
				key: 1,
			},
			{
				img: v2GuestStandard,
				imgActive: v2GuestWhite,
				name: 'account',
				text: 'Account',
				key: 2,
			},
			{
				img: v2AccountVenueSpaceStandard,
				imgActive: v2AccountVenueSpaceWhite,
				name: 'space',
				text: 'Configurations',
				key: 3,
			},
			{
				img: v2AdvancedAccountStandard,
				imgActive: v2AdvancedAccountWhite,
				name: 'store-settings',
				text: 'Store Settings',
				key: 4,
			},
			// {
			// 	img: v2AccountVenueSpaceStandard,
			// 	imgActive: v2AccountVenueSpaceWhite,
			// 	name: 'store-integrations',
			// 	text: 'Integrations',
			// 	key: 5,
			// },
			{
				img: v2TableStandard,
				imgActive: v2TableWhite,
				name: 'hygiene-standard',
				text: 'Hygiene Standards',
				key: 5,
			},
			{
				img: Cities,
				imgActive: Cities,
				name: 'cities',
				text: 'Cities',
				key: 6,
			},
			{
				img: Countries,
				imgActive: Countries,
				name: 'countries',
				text: 'Countries',
				key: 7,
			},
			{
				img: Genders,
				imgActive: Genders,
				name: 'genders',
				text: 'Genders',
				key: 8,
			},
		],
	},

	// {
	// 	img: v2LoyaltyStandard,
	// 	imgActive: v2LoyaltyWhite,
	// 	key: 6,
	// 	name: 'loyalty',
	// 	text: 'Loyalty',
	// 	menus: [
	// 		{
	// 			img: v2LoyaltyProgramStandard,
	// 			imgActive: v2LoyaltyProgramWhite,
	// 			name: 'programs',
	// 			text: 'Programs',
	// 			key: 1,
	// 		},
	// 		{
	// 			img: v2GuestsEnrolledStandard,
	// 			imgActive: v2GuestsEnrolledWhite,
	// 			name: 'guests-enrolled',
	// 			text: 'Enrolled Customers',
	// 			key: 2,
	// 		},
	// 	],
	// },

]

